import React from 'react';
import './BackgroundWrapper2.css';
import background from '../features/attackSurface/assets/background.png';

interface BackgroundWrapper2Props {
  children: React.ReactNode;
}

const BackgroundWrapper2: React.FC<BackgroundWrapper2Props> = ({ children }) => (
  <div className="background-wrapper-2">
    <img src={background} alt="" className="bg-img-2-main" />
    <div className="bg-grid-lines" />
    <div className="background-content-2">{children}</div>
  </div>
);

export default BackgroundWrapper2;